import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import TableItem from './table-item';
import { Box } from "@material-ui/core";
import TableHeader from './header';
import Loading from '../common/loading';
import TableContentNoData from '../common/table-content-no-data';
import { useTranslate } from 'react-admin';

function Index(props) {
    const { messages, onCheck, selectedItems, onEdit, onDelete, onMarkRead, onCheckAll, type, onChangeSortable, order, loading,checkall, isDelete, isUpdate } = props;
    const translate = useTranslate();

    return (
        <Fragment>
            <TableHeader
                selectedItems={selectedItems}
                type={type}
                onDelete={onDelete}
                onCheckAll={onCheckAll}
                onChangeSortable={onChangeSortable}
                order={order}
                checkall={checkall}
                isDelete={isDelete}
               
            />
            <Loading show={loading} />
            {
                !loading &&
                <Box>
                    <TableContentNoData show={messages.length === 0}>{translate('pos.common.noRecordsFound')}</TableContentNoData>
                    {
                        messages.map(item =>
                            <TableItem
                                item={item}
                                key={item.id + ''}
                                onEdit={onEdit}
                                onCheck={onCheck}
                                onDelete={onDelete}
                                onMarkRead={onMarkRead}
                                type={type}
                                isDelete={isDelete}
                                isUpdate={isUpdate}
                            />
                        )
                    }
                </Box>
            }
        </Fragment>
    );
}

Index.propTypes = {
    messages: PropTypes.array.isRequired,
    selectedItems: PropTypes.array.isRequired,
    checkAll: PropTypes.bool.isRequired,
    onCheck: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onMarkRead: PropTypes.func.isRequired,
    onCheckAll: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};

export default Index;
